import { PieChart } from '@/common/dashboard/charts/PieChart';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { useEffect, useState } from 'react';

const programTypeColors = ['#2e7d32', '#1976d2', '#ed6c02', '#00838f', '#6d8f00', '#5d6d7e'];

const colorForProgramType = (programType) => {
  const characterSum = [...programType].reduce((sum, character) => sum + character.charCodeAt(0), 0);
  return programTypeColors[characterSum % programTypeColors.length];
};

export const McoFinPaidByProgTypePieChart = ({ formValues, idToProgType }) => {
  const { rbtPeriodId, pbmIds, brandProdIds, progTypeIds } = formValues;
  const rsrc = useRsrc();
  const [data, setData] = useState([]);

  useEffect(() => {
    const reqParam = {
      periodId: rbtPeriodId,
      pbmIds,
      brandIds: brandProdIds,
      progTypes: progTypeIds.map((id) => idToProgType[id]),
    };

    rsrc.data('sc', 'MCO_FIN_PAID_BY_PROG_TYPE_PIE_CHART_DATA_PLUGIN', reqParam).then((data) => {
      setData(data.map((dataPoint) => ({ ...dataPoint, color: colorForProgramType(dataPoint.label) })));
    });
  }, [rbtPeriodId, pbmIds, brandProdIds, progTypeIds, idToProgType]);

  return <PieChart data={data} legend="bottom" centerLabel="Paid" centerSubLabel="by program type" />;
};